<template>
  <el-button
    :type="buttonType"
    :icon="icon"
    size="mini"
    v-bind="$attrs"
    @click="$emit('button-view-click')"
  ></el-button>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    default: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      buttonType: "default"
    };
  },
  created() {
    if (this.default) this.buttonType = "primary";
  }
};
</script>
